import React, { createContext, useState, useContext } from 'react';
import { Spinner } from '../../../../src/components/components/Spinner/Spinner';

interface SpinnerContextProps {
  showSpinner: () => void;
  hideSpinner: () => void;
}

const SpinnerContext = createContext<SpinnerContextProps>({
  showSpinner: () => {},
  hideSpinner: () => {},
});

let spinnerContext: SpinnerContextProps;

export const setSpinnerContext = (context: SpinnerContextProps) => {
  spinnerContext = context;
};

export const getSpinnerContext = () => spinnerContext;

export const SpinnerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showSpinner = () => setLoading(true);
  const hideSpinner = () => setLoading(false);

  // Set the spinner context here
  setSpinnerContext({ showSpinner, hideSpinner });

  return (
    <SpinnerContext.Provider value={{ showSpinner, hideSpinner }}>
      {loading && <Spinner loading={true} type="SyncLoader" />}
      {children}
    </SpinnerContext.Provider>
  );
};

export const useSpinner = () => useContext(SpinnerContext);